"use client";

import React from "react";
import { LoadingState } from "@/components/ui/states/LoadingState";

interface UniversalEntityPageStatesProps {
  authLoading: boolean;
  isAuthenticated: boolean;
  isEmployee: boolean;
  isAdmin: boolean;
  isClientUser: boolean;
  isLoading: boolean;
  data: any;
  config: any;
}

/**
 * Loading and error state rendering for UniversalEntityPage
 * Handles conditional rendering of auth, loading, and error states
 *
 * NOTE: Auth redirects are now handled by AuthGuard wrapper at the page level.
 * This component only handles loading and error states for data fetching.
 */
export function UniversalEntityPageStates({
  authLoading,
  isAuthenticated,
  isEmployee,
  isAdmin,
  isClientUser,
  isLoading,
  data,
  config,
}: UniversalEntityPageStatesProps): React.ReactNode {

  // Show loading while checking authentication
  if (authLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingState size="lg" message="Loading..." />
      </div>
    );
  }

  // Show loading while redirecting
  // CRITICAL FIX: Don't return null - return a proper error state to prevent downstream errors
  if (!isAuthenticated || (!isEmployee && !isAdmin && !isClientUser)) {
    // Return a proper loading state instead of null to prevent errors
    // The auth system will handle redirecting to login if needed
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingState size="lg" message="Redirecting to login..." />
      </div>
    );
  }

  // Loading state
  if (isLoading && !data) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingState size="lg" message={`Loading ${config.displayName.toLowerCase()}...`} />
      </div>
    );
  }

  // Error state - BYPASSED for now, errors are logged but don't block UI
  // if (error) {
  //   return (
  //     <div className="text-center py-12">
  //       <div className="text-red-600 mb-4">
  //         <FileText className="h-12 w-12 mx-auto mb-2" />
  //         <h3 className="text-lg font-medium">Error loading {config.displayName.toLowerCase()}</h3>
  //       </div>
  //       <p className="text-gray-600 mb-4">{error.message}</p>
  //       <Button onClick={handleRefetch}>
  //         Try Again
  //       </Button>
  //     </div>
  //   );
  // }

  // No error state - render normally
  return null;
}
